import type { RideSummary } from "../types/ride";
import { useUnits } from "../lib/units";
import { formatDistance, formatDuration, formatEnergy, formatSpeed } from "../lib/units";
import { StatCard } from "./StatCard";

export function SummaryPanel({ summary }: { summary: RideSummary }) {
  const { system } = useUnits();

  if (summary.totalRides === 0) {
    return (
      <div className="rounded-xl border border-dashed border-slate-300 p-8 text-center text-slate-500 dark:border-night-700 dark:text-night-400">
        No rides yet — upload your first recording to see stats here.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      <StatCard icon="🛹" label="Rides" value={String(summary.totalRides)} />
      <StatCard icon="📏" label="Total distance" value={formatDistance(summary.totalDistanceMeters, system)} />
      <StatCard icon="⏱️" label="Total time" value={formatDuration(summary.totalDurationSec)} />
      <StatCard icon="⚡" label="Energy used" value={formatEnergy(summary.totalWhUsed)} />
      <StatCard icon="💨" label="Top speed ever" value={formatSpeed(summary.maxSpeedMs, system)} sub={summary.fastestRide?.title} />
      <StatCard icon="📈" label="Avg speed" value={formatSpeed(summary.avgSpeedMs, system)} />
    </div>
  );
}
